export const AVATAR_DIMENSIONS = '76x76';
